import { IPoItem } from '../../interfaces/po-item';
import { Reducer } from 'redux';
import { IChangeRequestState } from '../../interfaces/change-request-interfaces';
import { CREATE_CHANGE_REQUEST } from './create-change-request-actions';
import { IChangeRequestDetail } from 'interfaces/change-request-detail';

const initialChangeRequestState: IChangeRequestState = {
  purchaseOrderItem: <IPoItem>{},
  changeRequestDetail: {} as IChangeRequestDetail,
  show: false,
  error: '',
  success: false,
  loading: false,
  changeRequestAlreadyExistsForItems: false
};

export const changeRequestReducer: Reducer<IChangeRequestState> = (state: IChangeRequestState = initialChangeRequestState, action) => {
  switch (action.type) {
    case CREATE_CHANGE_REQUEST.SHOW:
      return { ...state, show: true, ...action.payload };

    case CREATE_CHANGE_REQUEST.HIDE:
      return { ...state, show: false, error: '' };

    case CREATE_CHANGE_REQUEST.REQUEST:
      return { ...state, success: false, loading: true, error: '' };

    case CREATE_CHANGE_REQUEST.SUCCESS:
      return { ...state, success: true, show: false, error: '', loading: false, changeRequestAlreadyExistsForItems: action.payload.changeRequestAlreadyExistsForItems };

    case CREATE_CHANGE_REQUEST.FAILURE:
      return { ...state, error: 'Error occurred while creating change request.', success: false, loading: false };

    default:
      return state;
  }
};
